module.exports = "<gmt-construction-object-list [constructionObjects]=\"data.constructionObjects\" [showMore]=\"false\"></gmt-construction-object-list>\n"